// extracted by mini-css-extract-plugin
var _1 = "EditPencil__editButton--zrrd6";
var _2 = "EditPencil__editContainer--XsGRF";
export { _1 as "editButton", _2 as "editContainer" }
